export default __webpack_public_path__ + "static/media/ribboncuttin_w1024.98cacd6f.jpeg";